import request from '@/utils/request'
import config from '@/config'
export default {
  // 获取地区树列表
  getAdcdlist (params) {
    return request.get(config.ApiYJ + '/warninfo/adcdlist', { params })
  },
  // 根据地区得到列表
  getPersonlist (data) {
    return request.post(config.ApiYJ + '/warninfo/message_person_list', data)
  },
  // 根据预警id 获取人员信息
  person_order_warnid (params) {
    return request.post(config.ApiYJ + '/warninfo/person_order_warnid', params)
  },
  // 获取短信模板
  getMsgTempList (params) {
    return request.get(config.ApiYJ + '/MessageTemplate/MessageTemplateList', { params })
  },
  // 短信发送
  sendMsg (data) {
    return request.post(config.ApiYJ + '/warninfo/messagesending', data)
  },
  getNextadcdlist (params) {
    return request.get(config.ApiYJ + '/warninfo/nextadcdlist', { params })
  },
  getDeptlist (params) {
    return request.get(config.ApiYJ + '/warninfo/deptlist', { params })
  },
  getDepAdcdList (params) {
    return request.get(config.ApiYJ + '/warninfo/dept_and_adcdlist', { params })
  },
  getGrouplist (params) {
    return request.get(config.ApiYJ + '/warninfo/grouplist', { params })
  },
  savePersoninfo (params) {
    return request.post(config.ApiYJ + '/warninfo/savepersoninfo', params)
  },
  deletePersoninfo (params) {
    return request.post(config.ApiYJ + '/warninfo/deletepersoninfo', params)
  },
  // 预报预警查询--获取数据
  getProxyListForecastMessageDetail (params) {
    return request.get(config.ApiYJ + '/proxy/proxyListForecastMessageDetail', { params })
  },
  // 已发短信查询--获取数据
  getSendMessageQuery (params) {
    return request.get(config.ApiYJ + '/MessageSend/SendMessageQuery', { params })
  },
  // 已发短信查询--查看内短消息数据
  getSendMessageQueryLiablePerson (params) {
    return request.get(config.ApiYJ + '/MessageSend/SendMessageQueryLiablePerson', { params })
  },
  // 预警信息查看--获取数据
  getWarnRecordList (params) {
    return request.get(config.ApiYJ + '/WarnRecord/WarnRecordList', { params })
  },
  // 预警信息查看--新建/保存
  saveMessageTemplate (stationGroup) {
    return request.post(config.ApiYJ + '/MessageTemplate/SaveMessageTemplate', stationGroup)
  },
  // 预警信息查看--删除
  deleteMessageTemplate (params) {
    return request.post(config.ApiYJ + '/MessageTemplate/DeleteMessageTemplate', params)
  },
  // 预警信息查看--导出
  warnInfoListExport (params) {
    return request.post(config.ApiYJ + '/Export/WarnInfoListExport', params)
  },
  // 短信模板
  getMessageTemplateList (params) {
    return request.get(config.ApiYJ + '/MessageTemplate/MessageTemplateList', { params })
  },
  // 获得群组关系
  getPersonGroupRelation (params) {
    return request.get(config.ApiYJ + '/warninfo/GetPersonGroupRelation', { params })
  },
  // 保存群组关系信息
  savePersonGroupRelation (params) {
    return request.post(config.ApiYJ + '/warninfo/SavePersonGroupRelation', params)
  },
  // 获取自然村
  getnaturalvillagelist (params) {
    return request.get(config.ApiYJ + '/warninfo/naturalvillagelist', { params })
  },
  // 获取已配置群组信息
  getconfiguredlist (params) {
    return request.get(config.ApiYJ + '/warninfo/groupconfiguredlist', { params })
  },
  // 保存群组配置信息
  saveconfiguredinfo (configGroup) {
    return request.post(config.ApiYJ + '/warninfo/savegroupconfiguredinfo', configGroup)
  },
  // 一键配置
  oneclickconfiguration (configGroup) {
    return request.post(config.ApiYJ + '/warninfo/one_click_configuration', configGroup)
  },
  // 获取预警信息
  getStationmap (params) {
    return request.get(config.ApiYJ + '/warninfo/base_stationm_map_coordinate', { params })
  },
  // 行政区信息
  getNextAdcdList (params) {
    return request.get(config.ApiYJ + '/warninfo/nextadcdlist', { params })
  },
  // 预警信息-预警信息列表
  getEarlyWarningList (params) {
    return request.get(config.ApiYJ + '/WarnRecord/WarnRecordList', { params })
  },
  // 预警信息--新产生预警信息
  getNewEarlyWarning (params) {
    return request.get(config.ApiYJ + '/warninfo/new_early_warning', { params })
  },
  // 预警信息--改变预警状态信息
  changeMutipleWarning (params) {
    return request.post(config.ApiYJ + '/warninfo/change_warnStatus', params)
  },
  // 预警信息--获取乡镇下拉列表搜索信息
  getStreetAdcdList (params) {
    return request.get(config.ApiYJ + '/Base/AdcdExcept', { params })
  },
  // 预警中心责任人管理 导出
  exportPersonlist (params) {
    return request.post(config.ApiYJ + '/Export/WarinInfoPersonLiableExport', params)
  },
  // 预警中心责任人管理模板下载
  exportPersonTemplatelist (params) {
    return request.post(config.ApiYJ + '/Export/WarinInfoPersonLiableTemplateExport', params)
  },
  // 获取自然村树状列表数据
  getNaturalVillageTree () {
    return request.get(config.ApiYJ + '/warninfo/NaturalVillageTree')
  },
  // 短信导出
  sendMessageExport(params) {
    return request.post(config.ApiYJ + '/Export/SendMessageExport', params)
  },
  // 短信详情导出
  sendMessageQueryLiablePersonExport(params) {
    return request.post(config.ApiYJ + '/Export/SendMessageQueryLiablePersonExport', params)
  }
}
